import { Reveal, Btn, Eyebrow } from "../Bits";
import { IMAGES } from "../../lib/images";

const Positioning = () => (
  <section data-testid="home-positioning" className="relative bg-[#111111]">
    <div className="mako-grid-bg-dark absolute inset-0 opacity-60" aria-hidden="true" />
    <div className="relative mx-auto grid max-w-[1400px] items-center gap-14 px-6 py-20 lg:grid-cols-12 lg:gap-20 lg:px-10 lg:py-36">
      <div className="lg:col-span-6">
        <Reveal>
          <Eyebrow tone="light">Positioning</Eyebrow>
          <h2 className="mt-7 font-display text-3xl font-bold uppercase leading-[1] tracking-tight text-white sm:text-4xl lg:text-[3.5rem]">
            The foundation of
            <span className="block text-[#8AB4DA]">every round.</span>
          </h2>
          <p className="mt-8 max-w-xl text-sm leading-relaxed text-white/70 sm:text-base">
            A combat facility is only as good as the surface beneath it. MAKO creates professional
            mat and wall-padding systems built around performance, protection and the demands of
            daily training.
          </p>
          <div className="mt-11">
            <Btn to="/about" variant="ghostLight" data-testid="positioning-why-mako">
              Why MAKO
            </Btn>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.12} className="lg:col-span-6">
        <div className="relative">
          <div className="aspect-[5/4] overflow-hidden">
            <img
              src={IMAGES.mat_texture}
              alt="Close-up of a professional tatami-textured mat surface"
              loading="lazy"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-px left-0 h-[3px] w-1/3 bg-[#0F4C81]" />
          <div className="mt-6 flex items-center gap-4">
            <span className="mako-label text-[#7A7F85]">Surface detail</span>
            <span className="h-[1px] flex-1 bg-white/15" />
            <span className="mako-label text-white/50">Tatami texture</span>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Positioning;
